import { ENVIRONMENT, PLAYBACK_FRAMES_PER_SECOND } from '../../../../constants';

export const REDUX_NAMESPACE = 'SHARED/CREATIVES';

export const ASYNC_SANITIZE_ELEMENTS_WORKER_MSG =
  'ASYNC_SANITIZE_ELEMENTS_WORKER_MSG';
export const ASYNC_EXTRACT_SKIPPED_SHOTS_WORKER_MSG =
  'ASYNC_EXTRACT_SKIPPED_SHOTS_WORKER_MSG';

export const SNAP_LENGTH_MIN_SECONDS = 3;
export const SNAP_LENGTH_MAX_SECONDS = 10;
export const SNAP_LENGTH_ABSOLUTE_MAX_SECONDS = 180;
export const TIME_RANGE_MIN_FRAME = 0;
export const TIME_RANGE_ABSOLUTE_MAX_FRAME =
  Math.floor(SNAP_LENGTH_ABSOLUTE_MAX_SECONDS * PLAYBACK_FRAMES_PER_SECOND) - 1;

export const EPISODE_MAX_LENGTH_WIGGLE_ROOM_IN_SECONDS = 10;
export const EPISODE_LENGTH_ABSOLUTE_MAX_SECONDS = 3600; // 60 minutes
export const DEFAULT_EPISODE_LENGTH_MAX_SECONDS =
  ENVIRONMENT.DEFAULT_MAX_EPISODE_DURATION_SECONDS ||
  EPISODE_LENGTH_ABSOLUTE_MAX_SECONDS; // 7 minutes or 20 minutes
export const DEFAULT_EPISODE_LENGTH_MAX_SECONDS_FOR_ADVERTISER =
  ENVIRONMENT.DEFAULT_MAX_EPISODE_DURATION_SECONDS_FOR_ADVERTISER || 180; // 3 minutes

export const OPTIMISTIC_BUILD_TIME_PER_FRAME_MILLISECONDS = 300;
